import Scale from './Scale.js'


export default
{
    name: 'app-hexagon',

    props:
    {
        width: { type: Number, default: -1 },
        height: { type: Number, default: -1 },
        side: { type: Number, default: 50 },

        src: { type: String, default: null }
    },

    watch:
    {
        width: '_onWidthChange',
        height: '_onHeightChange',
        side: '_onSideChange',
        src: '_onSrcChange'
    },

    mounted()
    {
        this._canvas = this.$el
        this._context = this._canvas.getContext('2d')


        if (this.side > -1 && (this.width <= 0 || this.height <= 0))
        {
            this._onSideChange()
        }

        if (this.height > -1 && (this.width <= 0 || this.side <= 0))
        {
            this._onHeightChange()
        }

        if (this.width > -1 && (this.height <= 0 || this.side <= 0))
        {
            this._onWidthChange()
        }

        if (this.src !== null)
        {
            this._onSrcChange()
        }
    },

    methods:
    {
        //         -----
        //         IMAGE
        //         -----

        _onSrcChange()
        {
            const img = document.createElement('IMG')
            img.onload = this._draw
            img.src = this.src
            this._img = img
        },


        //        ------
        //        CANVAS
        //        ------

        _drawHexagon(xCenter, yCenter, side)
        {
            this._context.beginPath()

            for (let i = 0; i < 6; i++)
            {
                const a = (2 * i * Math.PI + Math.PI) / 6
                const x = xCenter + side * Math.cos(a)
                const y = yCenter + side * Math.sin(a)

                if (i < 1)
                {
                    this._context.moveTo(x, y)
                }
                else
                {
                    this._context.lineTo(x, y)
                }
            }

            this._context.closePath()
        },

        _drawImg(img)
        {
            const width = this._width
            const height = this._height

            const bounds = Scale.getBounds(width, height, img.width, img.height, Scale.TYPE_COVER)

            // this._context.drawImage(img, bounds.x, bounds.y + height * 0.1, bounds.w, bounds.h)
            this._context.drawImage(img, bounds.x, 0/*bounds.y*/, bounds.w, bounds.h)
        },

        _drawBg()
        {
            const width = this._width
            const height = this._height
            const ctx = this._context

            const grd = ctx.createRadialGradient(
                width * 0.5,
                height * 0.5,
                0,
                0,
                0,
                Math.sqrt(width * width + height * height))
            grd.addColorStop(0, '#1b1b1d')
            grd.addColorStop(1, '#141415')

            ctx.fillStyle = grd
            ctx.fillRect(0, 0, this._width, this._height)
            ctx.fill()
        },

        _draw()
        {
            if (!this._img)
            {
                return
            }

            const side = this._side
            const width = this._width
            const height = this._height

            this._canvas.width = width
            this._canvas.height = height


            // MASK
            this._context.save()
            this._drawHexagon(width * 0.5, side, side)
            this._context.clip()

            this._drawBg()
            this._drawImg(this._img)

            this._context.restore()

            this.$emit('load')
        },


        //      ----------
        //      SIDES SIZE
        //      ----------

        _onWidthChange()
        {
            const side = Math.sqrt(4 * Math.pow(this.width * 0.5, 2) / 3)

            this._side = side
            this._height = Math.round(side + side)
            this._width = this.width

            this._draw()
        },

        _onHeightChange()
        {
            const side = this.height * 0.5

            this._side = side
            this._height = this.height
            this._width = Math.round(2 * Math.sqrt(3 * side * side / 4))
            
            this._draw()
        },

        _onSideChange()
        {
            const side = this.side

            this._side = side
            this._height = Math.round(side + side)
            this._width = Math.round(2 * Math.sqrt(3 * side * side / 4))
            
            this._draw()
        }
    }
}


// WEBPACK FOOTER //
// ./src/scripts/components/app-hexagon/script.js